import {
  trigger,
  animate,
  transition,
  style,
  query
} from '@angular/animations';

export const fadeRouteAnimation = trigger('fadeRouteAnimation', [
  transition('* <=> *', [
    query(':enter', [style({ opacity: 0 })], { optional: true }),

    query(
      ':leave',
      [style({ opacity: 1 }), animate('.2s', style({ opacity: 0 }))],
      { optional: true }
    ),

    query(
      ':enter',
      [style({ opacity: 0 }), animate('.2s', style({ opacity: 1 }))],
      { optional: true }
    )
  ])
]);

export const fadeAnimation = trigger('fadeAnimation', [
  transition(':enter', [
    style({ opacity: '0' }),
    animate('.2s ease-out', style({ opacity: '1' })),
  ]),
  transition(':leave', [
    style({ opacity: '0' }),
    animate('.2s ease-out', style({ opacity: '0' })),
  ]),
]);

export const fadeInAnimation = trigger('fadeInAnimation', [
  transition(':enter', [
    style({ opacity: '0' }),
    animate('.2s ease-out', style({ opacity: '1' })),
  ])
]);

export const fadeOutAnimation = trigger('fadeOutAnimation', [
  transition(':leave', [
    style({ opacity: '1' }),
    animate('.2s ease-out', style({ opacity: '0' })),
  ])
]);
